import { render, staticRenderFns } from "./manufacturing-material-list-sync.vue?vue&type=template&id=3d1e5172&scoped=true&"
import script from "./manufacturing-material-list-sync.vue?vue&type=script&lang=js&"
export * from "./manufacturing-material-list-sync.vue?vue&type=script&lang=js&"
import style0 from "./manufacturing-material-list-sync.vue?vue&type=style&index=0&id=3d1e5172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e5172",
  null
  
)

export default component.exports